import React, { useState,useEffect} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button, Snackbar} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme, styled } from '@mui/material/styles'
import { login } from '../Redux/authSlice';
import ItemView from './ItemView';
import axios from 'axios';

const ContainerDialog = styled(Dialog, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'scroll',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  minHeight:600
})
);

const PremiumDialog = ({visible,setVisible})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [days,setDays] = useState(0)
const [message,setMessage] = useState("")
const [loading,setLoading] = useState(false)
const [open,setOpen] = useState(false)
const dispatch = useDispatch()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

// useEffect(() => {
// 	check_days()
// }, []);

	
// async function check_days() {
// 	try{
// 		const send_data = {
// 		email:user?.email
// 		}

// 	const checkDays = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}check-days/`,send_data).catch(err=>console.log(err))
		
// 		if (checkDays?.data.success == true && checkDays.status == 200) {
// 		setDays(checkDays?.data.days)   
// 		const userData = {
// 			...user,
// 			isPremiumExpired:checkDays?.data.isPremiumExpired
// 			}
// 		await dispatch(login(userData))
// 		}
// 	}catch(err){
// 		console.log(err)
// 	}
// }
	
async function handlePlan() {
try{
	setLoading(true)
	const send_data = {
		email:user?.email,
		type:"premium"
	}

const changePlan = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}change-plan/`,send_data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${user?.accessToken}`
              }
       }).catch(err=>console.log(err))
	
	if (changePlan?.data.success == true && changePlan.status == 200) {
		const userData = {
		...user,
		plan:changePlan?.data.plan,
		isPremiumExpired:changePlan?.data.isPremiumExpired
	}

		await dispatch(login(userData))
		setLoading(false)
		setMessage("You have paid for premium plan")
		setOpen(true)
		setVisible(false)
	
	}else{
		setLoading(false)
		setMessage(changePlan?.data.message)
		setOpen(true)
	}

}catch(err){
	console.log(err)
	setLoading(false)
}
}


return(    
	<ContainerDialog open={visible} onClose={onClose} >
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box  display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center" sx={{width:{sx:300,md:500}}}>
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Plans
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{justifyContent:"center",background:theme.palette.background.default}}>
			<Snackbar anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
                }} message={message} onClose={()=>{setOpen(false)}} open={open} autoHideDuration={2000}/>
			<Box  display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" sx={{width:{sx:300,md:400},marginLeft:2}}>
				<IconButton >
					<MenuIcon/>
				</IconButton>					
				<Typography style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
					Free Plan
				</Typography>		
			</Box>
			<Box>
			    <ItemView title="One Test creation / 3 month" content="Allow to create test as many as you want and any moments in 1 month"/>
				<ItemView title="0 $ / month " content="Free of use, no credit card needed"/>
				<ItemView title="Pass Tests" content="Take Tests anytime without limit"/>
				<ItemView title="Test training" content="10 Test training / month"/>
				<ItemView title="Test report" content="Access analytic tools and manage your Tests"/>
			</Box>
			<Box  display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center" sx={{width:{sx:300,md:500},marginLeft:2}}>
				<IconButton >
					<MenuIcon/>
				</IconButton>					
				<Typography style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
					Premium Plan
				</Typography>		
			</Box>
			<Box>
				<ItemView title="10 $ / month" content="Pay only 10 $ to gain access with advanced analytics graph"/>
				<ItemView title="Unlimited Test creation / month" content="Allow to create test as many as you want and any moments in 1 month"/>
				<ItemView title="Unlimited Test training" content="Create Test and learn by taking them from our Test training functionality"/>
				<ItemView title="Duplicate Tests" content="Gain the functionality to duplicate available tests even edit it for customization"/>
				<ItemView title="Test report" content="Access analytic tools and manage your Tests"/>
				<ItemView title="Test training" content="10 Test training / month"/>
				<ItemView title="Pass Tests" content="Take Tests anytime without limit"/>
				<Button onClick={(e)=>{
					e?.preventDefault()
					handlePlan()
				}} disabled={loading ? true : false} sx={{background:"gold",color:"black",marginTop:2,marginLeft:{sm:3,md:0},height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} variant="contained">
					{
						loading ? <CircularProgress size={15}/> : "Pay now"
					}
				</Button>
			</Box>
		</DialogContent>
	</ContainerDialog>
	)
}

export default PremiumDialog;